import React from "react";
import { CheckIcon } from "lucide-react";

interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
}) => {
  return (
    <label className="flex items-center gap-2 cursor-pointer select-none">
      <div
        className={`w-5 h-5 border-2 rounded flex items-center justify-center transition-all ${
          checked ? "bg-blue-600 border-blue-600" : "border-gray-400"
        }`}
        onClick={onChange}
      >
        {checked && <CheckIcon className="w-4 h-4 text-white" />}
      </div>
      {label && <span className="text-sm">{label}</span>}
    </label>
  );
};
